export default __webpack_public_path__ + "static/media/greeting20.afa98959.png";